/*
We will create ActionCreators which are functions that return action objects with two parameters :-

type : Used to identify the type of action we are sending. It is also used to differentiate between multiple actions.
payload : Used to hold any data that might be required to accompany the object.


Actions are payloads of information that send data from your application to your store. They are the only source of information for the store

*/

//import { NavigationActions } from 'react-navigation';
import AuthenticationApi from '../../api/AuthenticationApi';
import LocalStorage from '../../api/LocalStorage';

export function setLoginPending(isLoginPending) {
	return {
		type: 'SET_LOGIN_PENDING',
		isLoginPending
	};
}
export function setLoginSuccess(isLoginSuccess) {
	return {
		type: 'SET_LOGIN_SUCCESS',
		isLoginSuccess
	};
}
export function setLoginError(loginError) {
	return {
		type: 'SET_LOGIN_ERROR',
		loginError
	};
}
export function setUser(user) {
	return {
		type: 'SET_USER',
		user
	};
}

//THUNK
export function doLogin(vals) {
	return (dispatch) => {
		dispatch(setLoginPending(true));
		dispatch(setLoginSuccess(false));
		dispatch(setLoginError(null));

		//console.log(vals);
		AuthenticationApi.signIn(vals.user, vals.pass, (res) => {
			dispatch(setLoginPending(false));
			if (!res.error) {
				//LocalStorage saves user; access_token, refresh_token but NOT JWT
				res.userName = vals.user;
				LocalStorage.saveUserAsync(res);
				if (vals.remember) {
					LocalStorage.saveCredsAsync(vals);
					console.log('saving creds');
				} else {
					LocalStorage.removeCredsAsync(vals);
					console.log('deleting creds');
				}
				dispatch(setLoginSuccess(true));
				dispatch(setUser(res));
			} else {
				dispatch(setLoginError(res.error_description || true));
			}
		});
	};
}

/*
simpler:

return dispatch => doLogin(form)
    .then(() => dispatch({ type: 'LOGGED_IN' }))
    .catch(() => dispatch({ type: 'LOGIN_FAILED' }))

	*/

/*

eg

// Thunk function, it calls the getRepos action above after it receives the fetch response.
export function getRepoThunk() {
  return function(dispatch, getState) {
    fetch('https://api.github.com/repositories')
    .then(e => e.json())
      .then(function(response){
        console.log(response);
        var arr = response.slice(0,10);
        dispatch(getRepos(arr))
      })
      .catch((error) => {
        console.error(error,"ERRRRRORRR");
      });
  }
}
// Repo selected action
export function repoSelected(repo){
  return{
    type: 'Repo_Selected',
    payload: repo
  }
}

*/
